import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import styles from './index.module.scss';
import PropTypes from '../../utils/propTypes';

const { fileContainer } = styles;

const UploadFile = ({ onChange, accept, fileList }) => {
  const intl = useIntl();
  const [imageUrl, setImageUrl] = useState(
    fileList[0] && URL.createObjectURL(fileList[0]),
  );
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(fileList[0] && fileList[0]);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = (info) => {
    getBase64(info.file, (url) => {
      setLoading(false);
      setImageUrl(url);
      setFile(info.file);
    });
    onChange(info.file);
  };
  const uploadButton = (
    <Button icon={<UploadOutlined />} loading={loading}>
      {intl.formatMessage({ id: 'uploadFile.placeholder' }).toUpperCase()}
    </Button>
  );

  return (
    <Upload
      name="avatar"
      listType="picture"
      className="avatar-uploader"
      showUploadList={false}
      customRequest={() => {}}
      //action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
      //beforeUpload={beforeUpload}
      accept={accept}
      onChange={handleChange}
      beforeUpload={() => {
        setLoading(true);
        return false;
      }}
      fileList={fileList}
    >
      <div>
        {uploadButton} {file?.name}
      </div>
      {imageUrl && (
        <div className={fileContainer}>
          <img src={imageUrl} alt="avatar" style={{ maxHeight: '100%' }} />
        </div>
      )}
    </Upload>
  );
};

UploadFile.propTypes = {
  onChange: PropTypes.func.isRequired,
  accept: PropTypes.string,
  fileList: PropTypes.arrayOf(File),
};

UploadFile.defaultProps = {
  accept: '*',
  fileList: undefined,
};

export default UploadFile;
